export default "__VITE_ASSET__C3UNS5oP__"